import Icon from '../components/Icon.vue'

Icon.register({
  mosque: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M0 480v-320h128v320c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32zM579.2 288h-358.3c-17.9-17.4-28.8-37.3-28.8-58.9 0-52.9 41.8-93.8 87.9-122.9 42-26.5 80.6-57.8 112-96.2l8.1-10 8.1 10c31.3 38.5 70 69.8 112 96.2 46.1 29.1 87.9 70 87.9 122.9 0 21.6-11 41.5-28.8 58.9zM608 320c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32h-32v-64c0-17.7-14.3-32-32-32s-32 14.3-32 32v64h-64v-72c0-48-48-72-48-72s-48 24-48 72v72h-64v-64c0-17.7-14.3-32-32-32s-32 14.3-32 32v64h-32c-17.7 0-32-14.3-32-32v-128c0-17.7 14.3-32 32-32h416zM64 0c0 0 64 32 64 96v32h-128v-32c0-64 64-96 64-96z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/mosque.js
// module id = 1584
// module chunks = 0